import { isMobile, isTablet } from 'react-device-detect';

var mult = isMobile || isTablet ? 2 : 1;

export const BonusGameItems = {
	name: 'splash_progressive_bonus_view_holder',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'bonus_item_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bonus_item_1',
					type: 'Sprite',
					position: {
						x: 30,
						y: -window.innerHeight
					},
					components: [
						{
							name: 'bonus_item_special',
							type: 'AnimatedSprite',
							position: { x: 55, y: -30 },
							scale: { x: 0.4 * mult, y: 0.4 * mult },
							anchor: { x: 0.5, y: 0.5 },
							animation: {
								pattern: '01_CrystalStable$.png',
								start: 0,
								end: 71,
								speed: 0.5,
								precision: 2,
								loop: true
							}
						},
						{
							name: 'bonus_item_progress',
							type: 'Sprite',
							img: 'bonus_progress_item_1',
							position: {
								x: 0,
								y: 0
							},
							scale: { x: 0.9 * mult, y: 0.9 * mult }
						}
					]
				},
				{
					name: 'bonus_item_2',
					type: 'Sprite',
					position: {
						x: 200,
						y: -window.innerHeight
					},
					components: [
						{
							name: 'bonus_item_special',
							type: 'AnimatedSprite',
							position: { x: 55, y: 10 },
							scale: { x: 0.4 * mult, y: 0.4 * mult },
							anchor: { x: 0.5, y: 0.5 },
							animation: {
								pattern: '01_CrystalStable$.png',
								start: 0,
								end: 71,
								speed: 0.5,
								precision: 2,
								loop: true
							}
						},
						{
							name: 'bonus_item_progress',
							type: 'Sprite',
							img: 'bonus_progress_item_1',
							position: {
								x: 0,
								y: 40
							},
							scale: { x: 0.9 * mult, y: 0.9 * mult }
						}
					]
				},
				{
					name: 'bonus_item_3',
					type: 'Sprite',
					position: {
						x: 375,
						y: -window.innerHeight
					},
					components: [
						{
							name: 'bonus_item_special',
							type: 'AnimatedSprite',
							position: { x: 90, y: 10 },
							scale: { x: 0.8 * mult, y: 0.8 * mult },
							anchor: { x: 0.5, y: 0.5 },
							animation: {
								pattern: '03_Heart$.png',
								start: 0,
								end: 71,
								speed: 0.5,
								precision: 2,
								loop: true
							}
						},
						{
							name: 'bonus_item_progress',
							type: 'Sprite',
							img: 'bonus_progress_item_2',
							position: {
								x: 15,
								y: 40
							},
							scale: {
								x: 0.8 * mult,
								y: 0.8 * mult
							}
						},
						{
							name: 'text_wrapper',
							type: 'Sprite',
							anchor: { x: 0.5, y: 0.5 },
							components: [
								{
									name: 'text',
									type: 'Text',
									text: 'BONUS_HEART_TEXT',
									position: { x: 95, y: 59 },
									anchor: { x: 0.5, y: 0.5 }
								},
								{
									name: 'subtext',
									type: 'Text',
									text: 'BONUS_HEART_SUBTEXT',
									position: { x: 90, y: 80 },
									anchor: { x: 0.5, y: 0.5 }
								}
							]
						}
					]
				},
				{
					name: 'bonus_item_4',
					type: 'Sprite',
					position: {
						x: 600,
						y: -window.innerHeight
					},
					components: [
						{
							name: 'bonus_item_special',
							type: 'AnimatedSprite',
							position: { x: 55, y: -28 },
							scale: { x: 0.4 * mult, y: 0.4 * mult },
							anchor: { x: 0.5, y: 0.5 },

							animation: {
								pattern: '01_CrystalStable$.png',
								start: 0,
								end: 71,
								speed: 0.5,
								precision: 2,
								loop: true
							}
						},
						{
							name: 'bonus_item_progress',
							type: 'Sprite',
							img: 'bonus_progress_item_1',
							scale: { x: 0.9 * mult, y: 0.9 * mult },
							position: {
								x: 0,
								y: 5
							}
						}
					]
				},
				{
					name: 'bonus_item_5',
					type: 'Sprite',
					position: {
						x: 770,
						y: -window.innerHeight
					},
					components: [
						{
							name: 'bonus_item_special',
							type: 'AnimatedSprite',
							position: { x: 55, y: -15 },
							scale: { x: 0.4 * mult, y: 0.4 * mult },
							anchor: { x: 0.5, y: 0.5 },

							animation: {
								pattern: '01_CrystalStable$.png',
								start: 0,
								end: 71,
								speed: 0.5,
								precision: 2,
								loop: true
							}
						},
						{
							name: 'bonus_item_progress',
							type: 'Sprite',
							img: 'bonus_progress_item_1',
							position: {
								x: 0,
								y: 15
							},
							scale: { x: 0.9 * mult, y: 0.9 * mult }
						}
					]
				},
				{
					name: 'bonus_item_6',
					type: 'Sprite',
					position: {
						x: 930,
						y: -window.innerHeight
					},
					components: [
						{
							name: 'bonus_item_special',
							type: 'AnimatedSprite',
							position: { x: 94, y: -5 },
							scale: { x: 0.8 * mult, y: 0.8 * mult },
							anchor: { x: 0.5, y: 0.5 },
							animation: {
								pattern: '04_Star$.png',
								start: 0,
								end: 71,
								speed: 0.5,
								precision: 2,
								loop: true
							}
						},
						{
							name: 'bonus_item_progress',
							type: 'Sprite',
							img: 'bonus_progress_item_2',
							position: {
								x: 15,
								y: 28
							},
							scale: {
								x: 0.85 * mult,
								y: 0.85 * mult
							}
						},
						{
							name: 'text_wrapper',
							type: 'Sprite',
							anchor: { x: 0.5, y: 0.5 },
							components: [
								{
									name: 'text',
									type: 'Text',
									text: 'BONUS_STAR_TEXT',
									position: { x: 70, y: 28 }
								},
								{
									name: 'subtext',
									type: 'Text',
									text: 'BONUS_STAR_SUBTEXT',
									position: { x: 70, y: 60 }
								}
							]
						}
					]
				},
				{
					name: 'bonus_character',
					type: 'Sprite',
					position: {
						x: 0,
						y: 0
					},
					components: [
						{
							name: 'character_blur',
							type: 'AnimatedSprite',
							anchor: { x: 0.5, y: 0.5 },
							position: { x: 80, y: -60 },
							scale: { x: 1 * mult, y: 1 * mult },
							animation: {
								pattern: 'Dissapear_000$.png',
								start: 0,
								end: 19,
								speed: 1,
								precision: 2,
								loop: false,
								animatable: true
							}
						},
						{
							name: 'character',
							type: 'AnimatedSprite',
							anchor: { x: 0.5, y: 0.5 },
							position: { x: 80, y: -60 },
							scale: { x: 1 * mult, y: 1 * mult },
							animation: {
								pattern: 'Appear_000$.png',
								start: 0,
								end: 19,
								speed: 1,
								precision: 2,
								loop: false,
								animatable: true
							}
						}
					]
				}
			]
		}
	]
};
